import React, { useRef } from 'react';
import { useIsMobile } from '../hooks/useIsMobile';

interface MagneticEffectProps {
  children: React.ReactNode;
  strength?: number; // e.g., 20 means 20% of distance
  className?: string;
}

export const MagneticEffect: React.FC<MagneticEffectProps> = ({ children, strength = 30, className = '' }) => {
  const isMobile = useIsMobile();
  const elRef = useRef<HTMLDivElement>(null);
  
  if (isMobile) {
    return <div className={className}>{children}</div>;
  }

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = elRef.current;
    if (!el) return;
    
    const { clientX, clientY } = e;
    const { width, height, left, top } = el.getBoundingClientRect();
    const x = clientX - (left + width / 2);
    const y = clientY - (top + height / 2);
    
    // Using requestAnimationFrame for smoother updates
    requestAnimationFrame(() => {
        el.style.transform = `translate(${x * (strength / 100)}px, ${y * (strength / 100)}px)`;
    });
  };
  
  const handleMouseLeave = () => {
    const el = elRef.current;
    if (el) {
        requestAnimationFrame(() => {
            el.style.transform = 'translate(0px, 0px)';
        });
    }
  };

  return (
    <div 
      ref={elRef} 
      className={className} 
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ transition: 'transform 0.15s ease-out', willChange: 'transform' }}
    >
      {children}
    </div>
  );
};
